// extracted by mini-css-extract-plugin
export default {"whatsappFloatButton":"WhatsApp_whatsappFloatButton__fJd-5","breathing":"WhatsApp_breathing__IN5TV"};